import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AngularFirestore } from '@angular/fire/firestore';
import { ToastController } from '@ionic/angular';
import { AngularFireAuth } from '@angular/fire/auth';
import swal from 'sweetalert'
import { OneSignal } from '@ionic-native/onesignal/ngx';
import { AuthService } from './auth.service';
import * as firebase from 'firebase';
@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  public nombres
  public mensaje
  public role
  appid={
    APP_ID:'bb79d2c2-39e9-4b35-b3ef-43a401a63dba',
    ID:'251862337329'
  }
  constructor(private http: HttpClient,private oneSignal:OneSignal,
    private db:AngularFirestore,
    private tool:ToastController,
    private authService:AuthService,
    private auth:AngularFireAuth) {
     
     }

 /**
  * It takes a message object, gets the OneSignal ID of the user, and sends a push notification to that
  * user
  * @param msg - is the object that contains the title and message of the notification.
  */
  sendNotiPush(msg){

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    
    this.db.collection('usuarios').doc(msg.usuario).get().subscribe(m=>{
      console.log(msg)
      var raw = JSON.stringify({

        "app_id": "bb79d2c2-39e9-4b35-b3ef-43a401a63dba",
        "include_player_ids": [
          m.data()['oneSigID']
        ],
        "headings":{
          "en":msg.title
        },
        "data": {
          "foo": "bar"
        },
        "contents": {
          "en": msg.message
        }
      });
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json"); 
     fetch("https://onesignal.com/api/v1/notifications?Authorization=ZjljNDBiNjgtZTk2MC00ZDI4LWEwZDEtZjliYmYxODI4NDlm",{
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      }).then(response => response.text())
       .then((result)=>{
         var map=JSON.parse(result)
         console.log(map)
         if(map["errors"]){
          this.failedMessage()
         }else{
          this.toastMessage()
          if(msg.role=='3' || msg.role=='4'){
            this.registerLocalNotification(msg)
          }
          

         }
       })
    
        
    })
    
  }

 /**
  * It sends a notification to all the users with the role of 1.
  * @param msg - is the message that will be sent to the user.
  * pedido_init:Notification Type, for identifier a initzializated order, for a user
  * pedido_cancel.Notification type, for identifier a cancel order for a user
  */
  sendNotiPushPedido(msg){
    
    const id=Math.random().toString(36).substring(2);
    this.db.collection('usuarios', ref=>ref.where('role','==','1')).get().subscribe(j=>{
      j.forEach(o=>{
        if(o.data()['uid']== o.id && o.data()['tokenSigID'] && o.data()['pais'] == msg.franja){
          if(msg.type=='pedido_init'){

            msg.usuario=o.id
            
            msg.uid_noti=id
            this.sendNotiPush(msg) 
            this.registerNotificator(o.id,id)
            this.db.collection('notification-local').add(
              msg
            )
             
            
          }
          
          if(msg.type=='pedido_cancel'){
            this.db.collection('notification-local',ref=>ref.where('pedido','==',msg.pedido)).get().subscribe(m=>{
              m.forEach(b=>{
                  b.ref.update(
                    msg
                  ).then(()=>{
                    msg.usuario=o.id
                    this.sendNotiPush(msg)
                    this.registerNotificator(o.id,id)
                  })
                 
              })
            })
            
          
          }
       
        }
      
      })
    })
  }
  sendNotiPushSolicitud(msg){
    this.db.collection('usuarios',ref=>ref.where('pais','==',msg.franja)).get().subscribe(j=>{
      j.forEach(o=>{
        if(o.data()['role']=='1' && o.data()['tokenSigID']){
          msg.usuario=o.id
          this.sendNotiPush(msg)   
        }
      
      })
    })
  }

  sendNotiPushConfirmacionSolicitante(msg){
   
    
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    
    this.db.collection('solicitud_usuario').doc(msg.proveedor).get().subscribe(m=>{
    
      var raw = JSON.stringify({

        "app_id": "bb79d2c2-39e9-4b35-b3ef-43a401a63dba",
        "include_player_ids": [
          m.data()['oneSigID']
        ],
        "headings":{
          "en":msg.title
        },
        "data": {
          "foo": "bar"
        },
        "contents": {
          "en": msg.message
        }
      });
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json"); 
     fetch("https://onesignal.com/api/v1/notifications?Authorization=ZjljNDBiNjgtZTk2MC00ZDI4LWEwZDEtZjliYmYxODI4NDlm",{
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      }).then(response => response.text())
       .then((result)=>{
         var map=JSON.parse(result)
         console.log(map['errors'])
         if(map["errors"]){
          this.failedMessage()


         }else{
          this.toastMessage()
      

         }
       })
    
        
    })
    
     
  }
  async toastMessage(){
    let toast = await this.tool.create({
      color:'success',
      message: 'Mensaje Enviado',
      duration: 2000,
      position: 'bottom'
    })
    toast.present()

  }

  async failedMessage(){
    let toast = await this.tool.create({
      color:'danger',
      message: 'Ha fallado el envio,posiblemente el Usuario no ha activado las notificaciones para la app',
      duration: 2000,
      position: 'top'
    })
    toast.present()
  }

  enviarCorreo(correo:string,nombre:string){
    this.nombres=nombre
    console.log(correo)
    const headers = {'Authorization':'Basic ZjljNDBiNjgtZTk2MC00ZDI4LWEwZDEtZjliYmYxODI4NDlm', 'Content-Type': 'application/json'}  
    var url="https://onesignal.com/api/v1/notifications"
    var body={"app_id": "bb79d2c2-39e9-4b35-b3ef-43a401a63dba",
    "include_email_tokens" :[correo],
   "email_subject": "Bienvenido a MaxsellGlobal Erp",
   "email_body": `<html>
   <head>
      <script src="https://code.jquery.com/jquery-3.5.1.js" integrity="sha256-QWo7LDvxbWT2tbbQ97B53yJnYU3WhH/C8ycbRAkjPDc=" crossorigin="anonymous"></script>
      <link
          href="https://fonts.googleapis.com/css?family=Nunito:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i"
          rel="stylesheet">
          <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css" integrity="sha384-JcKb8q3iqJ61gNV9KGb8thSsNjpSL0n8PARn9HuZOnIxN0hoP+VmmDGMN5t9UJ0Z" crossorigin="anonymous">
        
          <script src="https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/js/bootstrap.min.js" integrity="sha384-B4gt1jrGC7Jh4AgTPSdUtOBvfO8shuf57BaghqFfPlYxofvL8/KUEfYiJOMMV+rV" crossorigin="anonymous"></script>
        <!-- Add references to the Azure Maps Map control JavaScript and CSS files. -->
        <link rel="stylesheet" href="https://atlas.microsoft.com/sdk/javascript/mapcontrol/2/atlas.min.css" type="text/css" />
        <script src="https://atlas.microsoft.com/sdk/javascript/mapcontrol/2/atlas.min.js"></script>
    
        <!-- Add a reference to the Azure Maps Services Module JavaScript file. -->
        <script src="https://atlas.microsoft.com/sdk/javascript/service/2/atlas-service.min.js"></script>
   </head>
    <body>
      <table class="body-wrap" style="font-family: 'Helvetica Neue',Helvetica,Arial,sans-serif; box-sizing: border-box; font-size: 14px; width: 100%; background-color: #f6f6f6; margin: 0;" bgcolor="#f6f6f6">
          <tbody>
              <tr style="font-family: 'Helvetica Neue',Helvetica,Arial,sans-serif; box-sizing: border-box; font-size: 14px; margin: 0;">
                  <td style="font-family: 'Helvetica Neue',Helvetica,Arial,sans-serif; box-sizing: border-box; font-size: 14px; vertical-align: top; margin: 0;" valign="top"></td>
                  <td class="container" width="600" style="font-family: 'Helvetica Neue',Helvetica,Arial,sans-serif; box-sizing: border-box; font-size: 14px; vertical-align: top; display: block !important; max-width: 600px !important; clear: both !important; margin: 0 auto;"
                      valign="top">
                      <div class="content" style="font-family: 'Helvetica Neue',Helvetica,Arial,sans-serif; box-sizing: border-box; font-size: 14px; max-width: 600px; display: block; margin: 0 auto; padding: 20px;">
                          <table class="main" width="100%" cellpadding="0" cellspacing="0" style="font-family: 'Helvetica Neue',Helvetica,Arial,sans-serif; box-sizing: border-box; font-size: 14px; border-radius: 3px; background-color: #fff; margin: 0; border: 1px solid #e9e9e9;"
                              bgcolor="#fff">
                              <tbody>
                                  <tr style="font-family: 'Helvetica Neue',Helvetica,Arial,sans-serif; box-sizing: border-box; font-size: 14px; margin: 0;">
                                      <td class="" style="font-family: 'Helvetica Neue',Helvetica,Arial,sans-serif; box-sizing: border-box; font-size: 16px; vertical-align: top; color: #fff; font-weight: 500; text-align: center; border-radius: 3px 3px 0 0; background-color: #cf4e2c; margin: 0; padding: 20px;"
                                          align="center" bgcolor="#cf4e2c" valign="top">
                                       
                                          <img src="https://firebasestorage.googleapis.com/v0/b/maxsellglobal-technology.appspot.com/o/maxsellgloball%2Fmaxsellglobal.jpg?alt=media&token=93487a39-1a28-434c-b140-6e3adcc5d72e" width="200" height="200">
  
                                      </td>
                                  </tr>
                                  <tr style="font-family: 'Helvetica Neue',Helvetica,Arial,sans-serif; box-sizing: border-box; font-size: 14px; margin: 0;">
                                      <td class="content-wrap" style="font-family: 'Helvetica Neue',Helvetica,Arial,sans-serif; box-sizing: border-box; font-size: 14px; vertical-align: top; margin: 0; padding: 20px;" valign="top">
                                          <table width="100%" cellpadding="0" cellspacing="0" style="font-family: 'Helvetica Neue',Helvetica,Arial,sans-serif; box-sizing: border-box; font-size: 14px; margin: 0;">
                                              <tbody>
                                                  <tr style="font-family: 'Helvetica Neue',Helvetica,Arial,sans-serif; box-sizing: border-box; font-size: 14px; margin: 0;">
                                                      <td class="content-block" style="font-family: 'Helvetica Neue',Helvetica,Arial,sans-serif; box-sizing: border-box; font-size: 14px; vertical-align: top; margin: 0; padding: 0 0 20px;" valign="top">
                                                         Hola <strong style="font-family: 'Helvetica Neue',Helvetica,Arial,sans-serif; box-sizing: border-box; font-size: 14px; margin: 0;">${this.nombres}</strong>
                                                      </td>
                                                  </tr>
                                                  <tr style="font-family: 'Helvetica Neue',Helvetica,Arial,sans-serif; box-sizing: border-box; font-size: 14px; margin: 0;">
                                                      <td class="content-block" style="font-family: 'Helvetica Neue',Helvetica,Arial,sans-serif; box-sizing: border-box; font-size: 14px; vertical-align: top; margin: 0; padding: 0 0 20px;" valign="top">
                                                          Bienvenido al sistema de integrado de control MaxsellGlobal ERP
                                                      </td>
                                                  </tr>
                                                 
                                                  <tr style="font-family: 'Helvetica Neue',Helvetica,Arial,sans-serif; box-sizing: border-box; font-size: 14px; margin: 0;">
                                                      <td class="content-block" style="font-family: 'Helvetica Neue',Helvetica,Arial,sans-serif; box-sizing: border-box; font-size: 14px; vertical-align: top; margin: 0; padding: 0 0 20px;" valign="top">
                                                          Gracias Por Elegirnos <b>MaxsellGlobal</b>Technology.
                                                      </td>
                                                  </tr>
                                              </tbody>
                                          </table>
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                          <div class="footer" style="font-family: 'Helvetica Neue',Helvetica,Arial,sans-serif; box-sizing: border-box; font-size: 14px; width: 100%; clear: both; color: #999; margin: 0; padding: 20px;">
                              <table width="100%" style="font-family: 'Helvetica Neue',Helvetica,Arial,sans-serif; box-sizing: border-box; font-size: 14px; margin: 0;">
                                  <tbody>
                                      <tr style="font-family: 'Helvetica Neue',Helvetica,Arial,sans-serif; box-sizing: border-box; font-size: 14px; margin: 0;">
                                          <td class="aligncenter content-block" style="font-family: 'Helvetica Neue',Helvetica,Arial,sans-serif; box-sizing: border-box; font-size: 12px; vertical-align: top; color: #999; text-align: center; margin: 0; padding: 0 0 20px;" align="center" valign="top"><a href="#" style="font-family: 'Helvetica Neue',Helvetica,Arial,sans-serif; box-sizing: border-box; font-size: 12px; color: #999; text-decoration: underline; margin: 0;">Cyberpneuma Tecnologias</a> ${new Date().getFullYear()}
                                          </td>
                                      </tr>
                                  </tbody>
                              </table>
                          </div>
                      </div>
                  </td>
                  <td style="font-family: 'Helvetica Neue',Helvetica,Arial,sans-serif; box-sizing: border-box; font-size: 14px; vertical-align: top; margin: 0;" valign="top"></td>
              </tr>
          </tbody>
      </table>
    </body>
  </html>`}
    this.http.post(url,body,{headers:headers}).subscribe(j=>{
      console.log(j)
    })
  }

  setupPushRegister(uid) {
    // I recommend to put these into your environment.ts
    var iosSettings = {};
    iosSettings["kOSSettingsKeyAutoPrompt"] = false;
    iosSettings["kOSSettingsKeyInAppLaunchURL"] = false;
    
    this.oneSignal.startInit(this.appid.APP_ID,this.appid.ID);
    this.oneSignal.promptForPushNotificationsWithUserResponse();
    this.oneSignal.inFocusDisplaying(this.oneSignal.OSInFocusDisplayOption.Notification);
    this.oneSignal.setSubscription(true);
    
  
    this.oneSignal.getIds().then(g=>{

   
      this.db.collection('solicitud_usuario',ref=>ref.where('numero','==',uid)).get().subscribe(o=>{
        o.forEach(l=>{
          l.ref.update({
            oneSigID:g.userId,
            tokenSigID:g.pushToken
          })
        })
      })
     
  })
  
 
    this.oneSignal.endInit();
  }


  /**
   * Notification service, for the differents actions or operations of  the differents users  
   */

  registerLocalNotification(json){
    const id=Math.random().toString(36).substring(2);
    json['uid_noti']=id
    this.db.collection('notification-local').add(
       json
    )
    this.registerNotificator(json.usuario,id)
  }
  
  registerNotificator(user,id){
    this.db.collection('usuarios').doc(user).update({
       notification:firebase.firestore.FieldValue.arrayUnion(id)
    })

  }
  requestNotifications(user){
    var noti=this.db.collection('notification-local',ref=>ref.where('usuario','==',user))
    return noti
  }

  slicingNotificator(user){
    console.log(user)
    this.db.collection('usuarios').doc(user).update({
      notification:[]
    })
  }

}
